import React, { PureComponent } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content'
import { errorAlert, successAlert } from '../../../../utils/alert.util';
import PropTypes from 'prop-types';
import {
  isEmpty, dropRight,
  map, noop, find, findIndex, cloneDeep, keys,
} from 'lodash';
import ListForm from '../../../../components/ListForm/ListForm.component';
import CashJournalForm from './components/CashJournalForm.component';
import { commaFormatted, normalizeAmount, dateFormat } from '../../../../utils/transformer.util';
import {
  FINANCE_CASH_JOURNAL_FORM_FIELDS,
  FINANCE_CASH_JOURNAL_RECONCILIATION_FORM,
  FINANCE_CASH_JOURNAL_STANDARD_FORM,
} from '../../../../constants/finance/finance.constant';
import Button from '../../../../components/base/Button/Button.component';
import CashJournalFormHeader from './components/CashJournalFormHeader.component';
import CashJournalFundRequest from './components/CashJournalFundRequest.component';

const MySwal = withReactContent(Swal);

const calculateTotal = (list = null) => {
  let total = 0;
  if (!isEmpty(list)) {
    for (let key in list) {
      let item = list[key];

      if(list[key] && list[key].hasOwnProperty('amount')) {
        item = list[key]['amount'];
      }
      if (item) {
        total += parseFloat(item);
      }
    };
  }
  return total;
};

export default class ManageCashJournal extends PureComponent {
  constructor(props) {
    super(props);
    this._onFormChange = this._onFormChange.bind(this);
    this._setForm = this._setForm.bind(this);
    this._onAddList = this._onAddList.bind(this);
    this._onClearForm = this._onClearForm.bind(this);
    this._onSubmit = this._onSubmit.bind(this);
    this._getCoaOptions = this._getCoaOptions.bind(this);
    this._showTaxForm = this._showTaxForm.bind(this);
    this._onTaxFormChange = this._onTaxFormChange.bind(this);
    this._calculateTax = this._calculateTax.bind(this);
    this._calculateSummary = this._calculateSummary.bind(this);
    this._showModal = this._showModal.bind(this);
    this._onCloseModal = this._onCloseModal.bind(this);
    this._renderFundRequests = this._renderFundRequests.bind(this);
    this._onSelectCoa = this._onSelectCoa.bind(this);
    this._onCheckFundRequest = this._onCheckFundRequest.bind(this);
    this._setSelectedFundRequest = this._setSelectedFundRequest.bind(this);
    this._handleDeleteJournalDetail = this._handleDeleteJournalDetail.bind(this);
    this.taxRecipientsParam = [];

    this.state = {
      counter: 0,
      form: {
        value: {
          date: dateFormat(new Date(), 'YYYY-MM-DD'),
          type: '',
          pos: '',
          reconciliation: [],
          standard: [],
        },
        error: {
          reconciliation: [],
          standard: [],
        },
      },
      availableFundRequests: {},
      selectedFundRequests: {},
      showTaxForm: false,
      taxType: null,
      summary: {
        totalGross: 0,
        totalNett: 0,
        totalTax: 0,
      },
    };
  }

  componentDidMount() {
    const { handleGetCoaOptions, location } = this.props;
    const { isEdit = false, data } = location.state;
    const { form } = this.state;
    const { value } = form;

    if (isEdit) {
      this._setForm(data.id);
    }

    this._getCoaOptions();
  }

  componentDidUpdate(prevProps, prevState) {
    const { form } = this.state;
    const { value } = form;
    const { form: prevForm } = prevState;
    const { value: prevValue } = prevForm;

    if (prevValue.type !== value.type ||
      prevValue.tipe !== value.tipe ||
      prevValue.pos !== value.pos ||
      prevValue.date !== value.date) {
      this._getCoaOptions();
    }
  }

  async _onSelectCoa(coa, index) {
    const { form } = this.state;
    const { tipe, type, pos, date } = form.value;
    const selectedCoa = coa.code || null;
    const { handleGetAvailableFundRequests } = this.props;
    if(tipe.toString() === '1' && type === 'KAS_KELUAR' && pos === 'ypl'){
      const fundRequests = await handleGetAvailableFundRequests({
          coa: selectedCoa,
          date: dateFormat(date, 'YYYY-MM-DD')
      });
      this.setState(prevState => ({
        ...prevState,
        availableFundRequests: {
          [selectedCoa]: {...fundRequests},
        }
      }), () => {
        if(!isEmpty(fundRequests)) {
          this._showModal(selectedCoa, index);
        }
      });
    }
  }

  _showModal(selectedCoa, index) {
    if(selectedCoa) {
      MySwal.fire({
        title: <p>Pilih Permohonan Dana</p>,
        html: this._renderFundRequests(selectedCoa, index),
      });
    }
    return false;
  }

  _onCloseModal(detailState, index) {
    const { form, counter } = this.state;
    const { value } = form;
    const { standard: standardForm } = value;
    const newStandardForm = cloneDeep(standardForm);
    const { details } = value;
    const { selected, unchecked, selectedCoa } = detailState;
    let newIndex = index;
    let selectedLength = keys(selected).length - 1;

    if((selectedLength + counter) > 10 ) {
      errorAlert({
        title: 'Tambah item jurnal gagal',
        message: 'JOURNAL_ITEM_EXCEED_LIMIT'
      })
      return false;
    }

    newStandardForm[newIndex]['budget_details'] = [];

    if (selected) {
      for(let key in selected) {
        let newItem = cloneDeep(newStandardForm[index]);
        newItem['budget_details'] = [];
        if(index !== newIndex) {
          newItem['budget_details'].push(key);
          newStandardForm.push(newItem);
        } else {
          newStandardForm[index]['budget_details'] = [];
          newStandardForm[index]['budget_details'].push(key);
        }
        newIndex++;
      }
    }
    // if (unchecked) {
    //   for(let key in unchecked) {
    //     delete newStandardForm[index]['budget_details'][key];
    //   }
    // }

    this.setState(prevState => ({
      ...prevState,
      counter: selectedLength + counter,
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          standard: [
            ...newStandardForm,
          ]
        }
      },
    }));
  }

  _renderFundRequests(selectedCoa, index) {
    const { availableFundRequests = {}, selectedFundRequests = {},
      form } = this.state;
    const { value } = form;
    const fundRequests = {...availableFundRequests[selectedCoa]} || {};

    return (
      <CashJournalFundRequest
        fundRequests={fundRequests}
        selectedFundRequests={selectedFundRequests}
        onChange={(detailState) => this._onCloseModal(detailState, index)}
        selectedCoa={selectedCoa}
      />);
  }

  _onCheckFundRequest(event) {
    const { target } = event;
    const { value, checked } = target;
    let newState = { ...this.state }

    newState = this._setSelectedFundRequest(newState, checked, value);

    this.setState({
      ...newState
    });
  }

  _setSelectedFundRequest(state = {}, checked = false, detailId = null) {
    const { budgets, selectedFundRequest } = this.props;
    const { checkedDetails = {}, form } = state;
    const { details = {} } = form.value;
    const newState = { ...state };
    let newRecommendations = newState.form.value.recommendations;

    if(!checked) {
      delete newState.checkedDetails[detailId];
      delete newRecommendations[detailId];
    } else {
      const detail = find(details, (o, key) => {
        return parseInt(key) === parseInt(detailId)
      });
      newState.checkedDetails[detailId] = detail;
      newRecommendations[detailId] = detail.amount;
    }
    newState.form.value.recommendations = newRecommendations;

    return newState;
  }

  _calculateSummary() {
    const { form } = this.state;
    const { value } = form;
    const { standard } = value;

    let totalGross = 0;
    let totalTax = 0;
    let totalNett = 0;

    if (standard && standard.length > 0) {
      standard.forEach((item) => {
        const { nominal, tax } = item;
        totalGross += normalizeAmount(nominal);
        if (tax && tax.tax_deduction) {
          totalTax += tax.tax_deduction;
        }
        totalNett = totalGross - totalTax;
      });
    }

    this.setState(prevState => ({
      ...prevState,
      summary: {
        totalGross,
        totalTax,
        totalNett,
      },
    }));
  }

  async _getCoaOptions(keyword = '') {
    const { form, showTaxForm, taxType } = this.state;
    const { value } = form;
    const { tipe: tipeForm, date } = value;
    const { handleGetCoaOptions, handleGetJournalCoaOptions } = this.props;
    const excludes = {
      groups: (typeof tipeForm !== 'undefined' && tipeForm.toString() === '2') ? [] : [12900],
      codes: [11101],
    };

    if (value.type === 'KAS_MASUK') {
      if (typeof tipeForm !== 'undefined' && tipeForm.toString() === '1') {
        excludes.groups = excludes.groups.concat([11100]);
        handleGetJournalCoaOptions({
          keyword,
          classes: [40000],
          excludes,
          is_credit: true,
          pos: value.pos,
          journal_type: 'KAS',
          date: dateFormat(date, 'YYYY-MM-DD'),
        });
      } else if (typeof tipeForm !== 'undefined' && tipeForm.toString() === '2') {
        handleGetCoaOptions({
          keyword,
          groups: [12900],
          excludes,
          is_credit: true,
          journal_type: 'KAS',
          date: dateFormat(date, 'YYYY-MM-DD'),
        });
      }
    } else if (typeof tipeForm !== 'undefined' && tipeForm.toString() === '1') {
      handleGetJournalCoaOptions({
        keyword,
        classes: [50000, 10000, 20000, 30000],
        excludes,
        pos: value.pos,
        journal_type: 'KAS',
        date: dateFormat(date, 'YYYY-MM-DD'),
      });
    } else if (tipeForm === '2') {
      handleGetCoaOptions({
        keyword,
        groups: [12900],
        excludes,
        journal_type: 'KAS',
        date: dateFormat(date, 'YYYY-MM-DD'),
      });
    }
  }

  async _setForm(id) {
    const { handleGetCashJournal } = this.props;
    try {
      const payload = await handleGetCashJournal({ id });
      this.setState(prevState => ({
        counter: (payload.tipe.toString() === '1') ? payload.details.standard.length : payload.details.reconciliation.length,
        form: {
          value: {
            id: payload.id,
            date: payload.date,
            type: payload.is_credit ? 'KAS_MASUK' : 'KAS_KELUAR',
            pos: payload.pos,
            number: payload.journal_number,
            submitted_by: payload.submitted_by,
            received_by: payload.accepted_by,
            unit: payload.unit_id,
            standard: map(payload.details.standard, list => ({
              code_of_account: list.parameter_code,
              description: list.description,
              nominal: Number(list.nominal, 0),
              budget_details: list.budget_details || [],
              tax: list.tax,
            })),
            reconciliation: map(payload.details.reconciliation, list => ({
              code_of_account: list.parameter_code,
              nominal: Number(list.nominal, 0),
              description: list.description,
            })),
            tipe: payload.tipe.toString(),
          },
          error: {
            reconciliation: [],
            standard: [],
          },
        },
        showTaxForm: prevState.showTaxForm,
      }), () => {
        this._calculateSummary();
      });
    } catch (err) {
      // err action
    }
  }

  _showTaxForm(newValue, arrayPosition) {
    const { form } = this.state;
    const { value } = form;
    const { tipe, standard } = value;
    let showTaxForm = false;
    let taxType = null;

    if (tipe === '2') {
      return false;
    }

    if (!isEmpty(standard)) {
      standard.forEach((item, index) => {
        if (!isEmpty(item)) {
          const { code_of_account } = item;
          const { code } = code_of_account;

          if (arrayPosition !== index) {
            if (code.toString().startsWith('515') || code.toString().startsWith('516')) {
              showTaxForm = true;
              taxType = '515';
            } else if (code.toString().startsWith('517')) {
              showTaxForm = true;
              taxType = '517';
            }
          }
        }
      });

      if (showTaxForm === false) {
        if (newValue.code.toString().startsWith('515') || newValue.code.toString().startsWith('516')) {
          showTaxForm = true;
          taxType = '515';
        } else if (newValue.code.toString().startsWith('517')) {
          showTaxForm = true;
          taxType = '517';
        }
      }
    }

    return {
      showTaxForm,
      taxType,
    };
  }

  async _calculateTax(idx) {
    const { handleCalculateTax } = this.props;
    const { form } = this.state;
    const { value: formValue } = form;
    const { standard } = formValue;

    if (standard && !isEmpty(standard) && standard[idx].tax) {
      const newList = standard;
      const item = standard[idx];
      const taxValues = item.tax;

      if (taxValues.recipient && taxValues.tax && taxValues.fields) {
        const res = await handleCalculateTax({
          data: {
            ...taxValues,
          },
        });

        if (res) {
          newList[idx].tax.tax_deduction = res[0].tax_deduction;

          this.setState(prevState => ({
            ...prevState,
            form: {
              value: {
                ...prevState.form.value,
                standard: [...newList],
              },
              error: {
                ...prevState.form.error,
              },
            },
          }));
        }
      }
    }

    return 0;
  }

  async _onTaxFormChange(name, value, idx) {
    this.setState((prevState) => {
      const {
        showTaxForm, taxType, counter, form,
      } = prevState;

      const { value: formValues } = form;
      const newList = [...formValues.standard];
      const newItem = { ...newList[idx] };
      const { code_of_account } = newItem;
      const { code } = code_of_account;
      const newTax = { ...newItem.tax };

      if (name === 'tax' || name === 'recipient' || name === 'tax_type') {
        newTax[name] = value;
      } else {
        newTax.fields[name] = value;
      }

      if (!code.toString().startsWith('515')) {
        delete newTax.ptkp;
        delete newTax.fields.working_day;
      }

      newList[idx].tax = newTax;

      return {
        counter,
        form: {
          value: {
            ...formValues,
            standard: newList,
          },
          error: {
            ...prevState.form.error,
          },
        },
        showTaxForm,
        taxType,
      };
    }, () => {
      this._calculateTax(idx);
      this._calculateSummary();
    });
  }

  _onFormChange(event) {
    const {
      name,
      value,
      dataset,
      checked,
      type,
    } = event.target;
    const {
      inputType = 'text', inputArray = false, arrayPosition = 0,
      fieldName,
    } = dataset;

    this.setState((prevState) => {
      const { form } = prevState;
      let newList = [];
      let newListError = [];
      let formattedValue = value;
      const taxConfig = {
        showTaxForm: false,
        taxType: null,
      };

      let codeString = '';

      if (name === 'tipe' || name === 'type' || name === 'pos') {
        let pos = form.value.pos;
        if((name === 'tipe' && value === '2')) {
          pos = null;
        }
        if(name === 'pos') {
          pos = value;
        }
        return {
          counter: 0,
          form: {
            value: {
              ...form.value,
              pos,
              [name]: formattedValue,
              reconciliation: [],
              standard: [],
            },
            error: {
              ...form.error,
              [name]: '',
              reconciliation: [],
              standard: [],
            },
          },
          showTaxForm: false,
          taxType: null,
        };
      }

      if (inputType === 'number') {
        formattedValue = normalizeAmount(value);
      }

      if (inputArray) {
        if (type === 'checkbox') {
          formattedValue = checked;
        }
        newList = form.value[fieldName];
        newListError = form.error[fieldName];
        newList[arrayPosition][name] = formattedValue;

        const { code_of_account } = newList[arrayPosition];
        codeString = (code_of_account) ? code_of_account.code.toString() : '';

        if (!isEmpty(newListError[arrayPosition])) {
          newListError[arrayPosition][name] = '';
        }

        if (codeString.startsWith('515') || codeString.startsWith('516') || codeString.startsWith('517')) {
          if (name === 'code_of_account') {
            if (!newList[arrayPosition].tax) {
              newList[arrayPosition] = {
                ...newList[arrayPosition],
                tax: {
                  fields: {},
                },
              };
            }
            if (!newList[arrayPosition].tax.fields) {
              newList[arrayPosition] = {
                ...newList[arrayPosition],
                tax: {
                  ...newList[arrayPosition].tax,
                  fields: {},
                },
              };
            }
          }

          if (name === 'nominal') {
            newList[arrayPosition].tax.fields.gross_income_per_month = normalizeAmount(value);
          }
        } else {
          newList[arrayPosition] = {
            ...newList[arrayPosition],
            tax: null,
          };
        }
      }

      return {
        ...prevState,
        form: {
          value: {
            ...form.value,
            ...(inputArray
              ? { [fieldName]: newList }
              : { [name]: formattedValue }),
          },
          error: {
            ...form.error,
            ...(inputArray
              ? { [fieldName]: newListError }
              : { [name]: '' }),
          },
        },
        selectedCoa: (name === 'code_of_account') ? value.code : prevState.selectedCoa,
        ...taxConfig,
      };
    }, () => {
      if (name === 'nominal') {
        this._calculateTax(arrayPosition);
        this._calculateSummary();
      }
      if (name === 'code_of_account') {
        this._onSelectCoa(value, arrayPosition);
      }
    });
  }

  _onAddList(fieldName) {
    const { counter } = this.state;
    if (counter < 10) {
      this.setState(prevState => ({
        counter: counter + 1,
        form: {
          value: {
            ...prevState.form.value,
            [fieldName]: [
              ...prevState.form.value[fieldName],
              {
                budget_details: [],
                tax: {},
              },
            ],
          },
          error: {
            ...prevState.form.error,
            [fieldName]: [
              ...prevState.form.error[fieldName],
              {},
            ],
          },
        },
      }));
    }
  }

  _onClearForm() {
    this.setState({
      counter: 0,
      form: {
        value: {},
        error: {},
      },
      showTaxForm: false,
      taxType: null,
    });
  }

  async _onSubmit(e) {
    e.preventDefault();
    const { form } = this.state;
    const {
      handleManageCashJournal,
      history,
    } = this.props;
    const res = await handleManageCashJournal(form.value, history.goBack);
  }

  _handleDeleteJournalDetail(idx, id, fieldName) {
    const { handleDeleteJournalDetail } = this.props;
    const { form, counter } = this.state;
    const { value } = form;
    const newList = [...value[fieldName]];
    const item = newList[idx];

    newList.splice(idx, 1);

    if (id) {
      handleDeleteJournalDetail({
        id: id
      });
    }

    this.setState(prevState => ({
      ...prevState,
      counter: counter - 1,
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          [fieldName]: newList,
        }
      }
    }));
  }

  render() {
    const {
      form, showTaxForm, taxType, summary,
    } = this.state;
    const { totalGross, totalTax, totalNett } = summary;
    const {
      coa, location, handleGetTaxPtkpParam, handleGetTaxRecipientParam,
      handleGetUnitOptions
    } = this.props;
    const { isEdit } = location.state;
    const {
      reconciliation,
      standard,
      tipe,
      type,
      is_posted,
      is_reconciliation
    } = form.value;
    const {
      reconciliation: reconciliationErrors,
      standard: standardErrors,
    } = form.error;
    return (
      <div className="manage-cash-journal">
        <form onSubmit={this._onSubmit}>
          <CashJournalFormHeader
            form={form}
            coa={coa}
            onFormChange={this._onFormChange}
            isDebit={type==='KAS_KELUAR'}
            showEdit={isEdit}
            onSearchUnit={handleGetUnitOptions}
          />
          {
            type && (tipe === '1' || !isEmpty(standard)) && (
              <div>
                <CashJournalForm
                  showTax={type === 'KAS_KELUAR'}
                  isPosted={is_posted}
                  title="Standard"
                  listField={FINANCE_CASH_JOURNAL_STANDARD_FORM}
                  error={standardErrors}
                  list={standard}
                  coa={coa}
                  fieldName="standard"
                  onAddList={this._onAddList}
                  onChange={this._onFormChange}
                  onSearchCoa={this._getCoaOptions}
                  showTaxForm={showTaxForm}
                  onTaxFormChange={this._onTaxFormChange}
                  taxType={taxType}
                  isReconciliation={is_reconciliation ? true : false}
                  getTaxRecipientParam={handleGetTaxRecipientParam}
                  getTaxPtkpParam={handleGetTaxPtkpParam}
                  onDeleteJournalDetail={this._handleDeleteJournalDetail}
                  tipe={tipe}
                />
              </div>
            )
          }
          {
            type && (tipe === '2' || !isEmpty(reconciliation)) && (
              <div>
                <CashJournalForm
                  showTax={false}
                  isPosted={is_posted}
                  coa={coa}
                  title="Rekonsiliasi"
                  listField={FINANCE_CASH_JOURNAL_RECONCILIATION_FORM}
                  error={reconciliationErrors}
                  list={reconciliation}
                  fieldName="reconciliation"
                  onAddList={this._onAddList}
                  onChange={this._onFormChange}
                  onSearchCoa={this._getCoaOptions}
                  isReconciliation={is_reconciliation ? true : false}
                  onDeleteJournalDetail={this._handleDeleteJournalDetail}
                  tipe={tipe}
                />
              </div>
            )
          }
          <div className="manage-cash-journal__footer">
            <div>
              <h2>Total Bruto: Rp {commaFormatted(totalGross)}</h2>
              <h2>Total Neto: Rp {commaFormatted(totalNett)}</h2>
            </div>
            <Button
              type="submit"
              title="Simpan"
            />
          </div>
        </form>
      </div>
    );
  }
}

ManageCashJournal.propTypes = {
  handleGetAvailableFundRequests: PropTypes.func,
  handleGetTaxPtkpParam: PropTypes.func,
  handleGetTaxRecipientParam: PropTypes.func,
  handleCalculateTax: PropTypes.func,
  handleGetCoaOptions: PropTypes.func,
  handleGetJournalCoaOptions: PropTypes.func,
  handleManageCashJournal: PropTypes.func,
  handleGetCashJournal: PropTypes.func,
  handleGetUnitOptions: PropTypes.func,
  handleDeleteJournalDetail: PropTypes.func,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  coa: PropTypes.object.isRequired,
  unit: PropTypes.object,
};
ManageCashJournal.defaultProps = {
  handleGetAvailableFundRequests: noop,
  handleGetTaxPtkpParam: noop,
  handleGetTaxRecipientParam: noop,
  handleCalculateTax: noop,
  handleGetCoaOptions: noop,
  handleGetJournalCoaOptions: noop,
  handleGetCoa: noop,
  handleManageCashJournal: noop,
  handleGetCashJournal: noop,
  handleGetUnitOptions: noop,
  handleDeleteJournalDetail: noop,
  unit: {},
};
